<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Report Purchase by Period</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
              <div class="form-group col-3">
                <label for="subject">Start Date</label>
                <flat-pickr class="form-control" v-model="reportPurchasePeriod.startDate" ></flat-pickr>
              </div>
              <div class="form-group col-3">
                <label for="subject">To Date</label>
                <flat-pickr class="form-control" v-model="reportPurchasePeriod.toDate"></flat-pickr>
              </div>
             <div class="form-group col-6">
              <label for="uom">Supplier</label>
              <app-lookup-field :model="reportPurchasePeriod" :element="supplierLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportPurchasePeriod } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportPurchasePeriod: {...reportPurchasePeriod},
        supplierLookup: {
            id: 'supplier-lookup',
            title: 'Supplier',
            type: 'form',
            apiUrl: 'supplier-list',
            filter: ['name'],
            fields: [
                {
                    placeholder: 'Name',
                    width: 6,
                    column: 'supplierName'
                },
            ],
            dtElements: [
                {
                title: 'Name',
                column: 'name'
                },
            ],
            affectedField: [
            {
                from: 'id',
                to: 'supplierId'
            },
            {
                from: 'name',
                to: 'supplierName'
            }
            ]
        },
      }
    },
    async created() {

    },
    methods: {
      async print() {
      const rptApi = api('print/report-purchase-period')
      const query = { 
        params: {
          startDate: this.reportPurchasePeriod.startDate,
          toDate: this.reportPurchasePeriod.toDate,
          supplierId: this.reportPurchasePeriod.supplierId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Purchase.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
      const currentPurchasePeriod = this.reportPurchasePeriod
      this.reportPurchasePeriod = {
          ...currentPurchasePeriod,
          ...data
      }
    },
    finishUpload(data) {
      const currentPurchasePeriod = this.reportPurchasePeriod
      this.reportPurchasePeriod = {
        ...currentPurchasePeriod,
        ...data
      }
    },
    }
}
</script>